import { NodeClasses } from "./NodeClasses";

export function nodes(
  rootNode: any,
  nodeClasses: NodeClasses[],
  name?: string
): any {
  const enrichedNodeClasses: NodeClasses[] = [];
  if (nodeClasses.length > 0) {
    enrichedNodeClasses.push(...nodeClasses);
    if (enrichedNodeClasses.includes(NodeClasses.TAG)) {
      enrichedNodeClasses.push(NodeClasses.DEVICE);
      enrichedNodeClasses.push(NodeClasses.EXTENSION);
    }
    if (
      enrichedNodeClasses.includes(NodeClasses.EXTENSION) ||
      enrichedNodeClasses.includes(NodeClasses.PANEL)
    ) {
      enrichedNodeClasses.push(NodeClasses.CROP);
    }
    enrichedNodeClasses.push(NodeClasses.AREA);
  }
  const result: any = findNodes(
    rootNode,
    nodeClasses,
    enrichedNodeClasses,
    name ? new RegExp(name, "gi") : undefined
  );
  return result;
}

// TODO the filters (nodeClassFilter and nameFilter) are ANDed!
function findNodes(
  rootNode: any,
  nodeClasses: NodeClasses[] = [],
  enrichedNodeClasses: NodeClasses[] = [],
  nameRegExp?: RegExp
): any {
  const rootNodeNodeClass: NodeClasses =
    NodeClasses[rootNode.nodeClassName as keyof typeof NodeClasses];
  // TODO if parent is matched, then all children should be matched
  if (
    nameRegExp &&
    ((nodeClasses.length === 0 && rootNodeNodeClass === NodeClasses.TAG) ||
      nodeClasses.includes(rootNodeNodeClass)) &&
    rootNode.displayName.match(nameRegExp) === null
  ) {
    return undefined;
  }

  const result = { ...rootNode };
  result.children = [];
  rootNode.children.forEach((node: any) => {
    const currentNodeClass: NodeClasses =
      NodeClasses[node.nodeClassName as keyof typeof NodeClasses];
    if (
      nodeClasses.length === 0 ||
      enrichedNodeClasses.includes(currentNodeClass)
    ) {
      const subNode = findNodes(
        node,
        nodeClasses,
        enrichedNodeClasses,
        nameRegExp
      );
      // filter check depends on original nodeClasses, e.g., if the user looks for Area nodes also empty areas should be returned!
      // node.canHaveChildren()
      // If node has no children then only add it if it is explicitly included in thte nodeClasses parameter
      if (
        subNode &&
        /*nodeClasses.length === 0 ||*/ !(
          ((currentNodeClass === NodeClasses.AREA &&
            !nodeClasses.includes(NodeClasses.AREA)) ||
            (currentNodeClass === NodeClasses.CROP &&
              !nodeClasses.includes(NodeClasses.CROP)) ||
            (currentNodeClass === NodeClasses.DEVICE &&
              !nodeClasses.includes(NodeClasses.DEVICE)) ||
            (currentNodeClass === NodeClasses.EXTENSION &&
              !nodeClasses.includes(NodeClasses.EXTENSION))) &&
          subNode.children.length === 0
        )
      ) {
        result.children.push(subNode);
      }
    }
  });
  return result;
}

// const PARENT_MAP = {
//   [NodeClasses.AREA]: [
//     NodeClasses.CROP,
//     NodeClasses.EXTENSION,
//     NodeClasses.DEVICE,
//     NodeClasses.PANEL,
//     NodeClasses.AREA
//   ],
//   [NodeClasses.CROP]: [NodeClasses.EXTENSION, NodeClasses.PANEL],
//   [NodeClasses.DEVICE]: [NodeClasses.TAG],
//   [NodeClasses.EXTENSION]: [NodeClasses.TAG],
//   [NodeClasses.PANEL]: [],
//   [NodeClasses.TAG]: [NodeClasses.EXTENSION] // TODO really?
//   // [NodeClasses.EVENT]: [NodeClasses.EVENT],
// };
